import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import HeaderName from '../../Components/headerName';
import Loading from '../../Components/loading';
import LeaderCard from '../../Components/leaderCard';
import { updateStatus } from './LeaderData';

const LeadersHub = ({ isNeeded = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const profileData = useSelector((store) => store.company?.profile);

  const [loading, setLoading] = useState(false);
  const [loadingDashboard, setLoadingDashboard] = useState(false);
  const [addonsList, setAddonsList] = useState([]);


  useEffect(() => {
    const updatedArr = updateStatus(profileData);
    setAddonsList(updatedArr);
  }, [profileData]);

  // useEffect(() => {
  //   setLoading(true);
  // }, []);

  if (loading) return <Loading />;

  return (
    <div>
      {loadingDashboard && (
        <HoverWrapper>
          <Loading />
        </HoverWrapper>
      )}
      <HeaderWrapper>
        <HeaderName>{t('leadersHub')}</HeaderName>
      </HeaderWrapper>

      <div>
        <Section>
          {addonsList.map((item, index) => (
            <LeaderCard key={index} data={item} />
          ))}
        </Section>
      </div>
    </div>
  );
};

const HoverWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background: #ffffffc7;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const Section = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap:20px;
  flex-wrap: wrap;
`;


export default memo(LeadersHub);
